import useMutation from "../useMutation";

export default function useWarehouseTransferImportSeries(id) {
  return useMutation({
    path: `/api/v1/warehouse-transfers/${id}/transfer-details/export`,
    method: "POST",
  });
}
